export default "__VITE_ASSET__B$kjlqFV__"